var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSubscriptionHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 180,
    viewBox: "0 0 289 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 29.125,
    width: 178,
    height: 115,
    rx: 7,
    stroke: "#FF5F00",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 29.25V21.5C72.5 17.0817 76.0817 13.5 80.5 13.5H208.5C212.918 13.5 216.5 17.0817 216.5 21.5V29.25",
    stroke: "#807E7E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248 86.625H279.5",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248 77.625H268.25",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248 95.625H268.25",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86.625L9.5 86.625",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95.625L20.75 95.625",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77.625L20.75 77.625",
    stroke: "#FF5F00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 55.625,
    y: 52.875,
    width: 178.875,
    height: 24.75,
    fill: "#FF5F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 117.125C73.5 113.259 76.634 110.125 80.5 110.125H132C135.866 110.125 139 113.259 139 117.125V119.125C139 122.991 135.866 126.125 132 126.125H80.5C76.634 126.125 73.5 122.991 73.5 119.125V117.125Z",
    stroke: "#FF5F00",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 118.125,
    r: 9,
    fill: "#FF5F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.875 167.625H194",
    stroke: "#F2F2F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubscriptionHistory);
export default __webpack_public_path__ + "static/media/noSubscriptionHistory.f3c0fdcff9f40d8c39145285a3eb7685.svg";
export { ForwardRef as ReactComponent };